module.exports = __webpack_public_path__ + "static/media/openPadlockIcon.a65d08ea.svg";